import { ReactNode, useState, JSX } from "react";
import { Dialog, Portal } from "@chakra-ui/react";
import { Button } from "./ui/button";

interface IConfirmationDialogProps {
  trigger: ReactNode;
  dialogTitle: string;
  dialogText: string | JSX.Element;
  confirmButtonText?: string;
  cancelButtonText?: string;
  confirmationFn: () => void;
  confirmationIsPending?: boolean;
  isAlert?: boolean;
  isPendingText?: string;
}

function ConfirmationDialog({ trigger, dialogTitle, dialogText, cancelButtonText = "Cancel", confirmButtonText = "Confirm", confirmationFn, confirmationIsPending, isAlert, isPendingText = "Loading" }: IConfirmationDialogProps) {
  const [open, setOpen] = useState<boolean>(false);

  const onConfirm = () => {
    confirmationFn();
    setOpen(false);
  };

  return (
    <Dialog.Root
      placement="center"
      motionPreset="slide-in-bottom"
      lazyMount
      open={open}
      onOpenChange={() => setOpen(!open)}
      role={isAlert ? "alertdialog" : "dialog"}
      size="sm"
    >
      <Dialog.Trigger asChild>
        {trigger}
      </Dialog.Trigger>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>{dialogTitle}</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <p>
                {dialogText}
              </p>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">{cancelButtonText}</Button>
              </Dialog.ActionTrigger>
              <Button colorPalette={isAlert ? "red" : "blue"} loading={confirmationIsPending} loadingText={isPendingText} onClick={onConfirm}>
                {confirmButtonText}
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}

export default ConfirmationDialog;
